import styled from 'styled-components'

export const Container = styled.div`
	border-radius: 4px;
	margin: 12px 0;
`
